export default __webpack_public_path__ + "static/media/filling_1.e729e374.jpg";